export default __webpack_public_path__ + "static/media/fondo.aa8c078f.jpg";